import React from 'react'
import SatsueiDataMediaArea from '../shared/SatsueiDataMediaArea'
import { satsueiDataTorokuService } from '../../services/satsueiDataTorokuService'

const SatsueiDataTorokuMediaArea = ({
  onAnnotation,
  onPixClient,
  onScanSnap,
  onCamera,
  onVoiceRecognition,
  cameraDisabled,
  pixClientDisabled,
  voiceRecognitionDisabled,
  ocrDisabled,
  userPixCameraUsage,
  userPixClientUsage,
  userVoiceRecognitionUsage,
  userOcrUsage,
  ...props
}) => {
  return (
    <SatsueiDataMediaArea
      mode="edit"
      service={satsueiDataTorokuService}
      serviceParams={[]}
      onAnnotation={onAnnotation}
      onPixClient={onPixClient}
      onScanSnap={onScanSnap}
      onCamera={onCamera}
      onVoiceRecognition={onVoiceRecognition}
      cameraDisabled={cameraDisabled}
      pixClientDisabled={pixClientDisabled}
      voiceRecognitionDisabled={voiceRecognitionDisabled}
      ocrDisabled={ocrDisabled}
      userPixCameraUsage={userPixCameraUsage}
      userPixClientUsage={userPixClientUsage}
      userVoiceRecognitionUsage={userVoiceRecognitionUsage}
      userOcrUsage={userOcrUsage}
      {...props}
    />
  )
}

export default SatsueiDataTorokuMediaArea
